module.exports = __webpack_public_path__ + "img/vehicle_car.f5aeb868.svg";